import { ScoreCriteriaDetailTypeEnum as SearchScoreCriteriaDetailTypeEnum } from '@empathybroker/tsclient-search';

export enum RootScoreCriteriaDetailTypeEnum {
  CATALOG_DEFINITION = 'catalogDefinition',
  BUSINESS_RULES = 'businessRules',
  QUERY_CONTEXT = 'queryContext',
  USER_CONTEXT = 'userContext'
}

const { CONFIGURATION, CONTEXTUALIZE, ...BaseScoreCriteriaDetailTypeEnum } = SearchScoreCriteriaDetailTypeEnum;
export type BaseScoreCriteriaDetailTypeEnum = Exclude<SearchScoreCriteriaDetailTypeEnum, (
  SearchScoreCriteriaDetailTypeEnum.CONFIGURATION
  | SearchScoreCriteriaDetailTypeEnum.CONTEXTUALIZE
  )>;

export enum ConfigurationScoreCriteriaDetailTypeEnum {
  BASE_CONFIGURATION = 'baseConfiguration',
  QUERY_CONFIGURATION = 'queryConfiguration'
}

export enum CustomScoreCriteriaDetailTypeEnum {
  CUSTOM_SCORE = 'customScore',
}

export const ScoreCriteriaDetailTypeEnum = {
  ...RootScoreCriteriaDetailTypeEnum,
  ...BaseScoreCriteriaDetailTypeEnum,
  ...ConfigurationScoreCriteriaDetailTypeEnum,
  ...CustomScoreCriteriaDetailTypeEnum
};
export type ScoreCriteriaDetailTypeEnum = (
  RootScoreCriteriaDetailTypeEnum
  | BaseScoreCriteriaDetailTypeEnum
  | ConfigurationScoreCriteriaDetailTypeEnum
  | CustomScoreCriteriaDetailTypeEnum
  );
